import { gql } from "@apollo/client";

export const CANCEL_ORDER = gql`
mutation Mutation($awbNumber: String!) {
  cancelCourier(awbNumber: $awbNumber) {
    id
    awb_number
  }
}
`

export const CREATE_ORDER = gql`
mutation Mutation($input: OrderInput!) {
  addOrder(input: $input) {
    id
    order_number
    payment_type
    codCollectableValue
    pickupAddress {
      name
      phone
      address1
      city
      stateId {
        id
        name
      }
      zipCode
    }
    deliveryAddress {
      name
      phone
      address1
      city
      zipCode
       stateId {
        id
        name
      }
      customerId
    }
    order_amount
    ProductPrice
    ProductName
    status
    package_weight_Length
    order_id
    paymentSessionId
  }
}
`;
export const CONFIRM_THIRDPARTY_ORDER = gql`
mutation ConfirmThirdPartyOrder($confirmThirdPartyOrderId: ID) {
  confirmThirdPartyOrder(id: $confirmThirdPartyOrderId) {
    id
  }
}
`;
export const BULK_ADD_ORDER = gql`
  mutation BlulkAddOrder($input: [OrderInput]) {
    BlulkAddOrder(input: $input) {
       id
       paymentSessionId 
    }
  }
`  ;


export const ORDER_MENIFETCH = gql`
mutation OrderMenifetch($orderId: String) {
  orderMenifetch(orderId: $orderId)
}
`


export const REFUND_ORDER_MUTATION = gql`
 mutation RefundOrder($refundOrderId: String, $orderId: String, $refundAmount: Float, $isRefund: Boolean) {
  refundOrder(id: $refundOrderId, orderId: $orderId, refundAmount: $refundAmount, isRefund: $isRefund) {
    success
    message
  }
}
`;

export const UPDATE_TODAY_PAYMENT_STATUS = gql`
mutation UpdateTodayOpenCloseStatus($input: OrderInput) {
  updateTodayOpenCloseStatus(input: $input) {
    isOpenTodayPayment
  }
}
`

export const UPDATE_BULK_ORDER_STATUS = gql`
  mutation UpdateTodayOpenCloseStatusBulk($input: OrderInputData) {
    updateTodayOpenCloseStatusBulk(input: $input)
  }
`;


export const CREATE_NDR = gql`
mutation CreateNDRAction($input: [NdrInput]) {
  createNDRAction(input: $input) {
    id
  }
}
`